import { ClaimControllerApi } from "../../../services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "../../../utils/utils";

interface Params {
  claimId: string;
  claimType: string;
}

/**
 *
 * @author [Rajkumar Rathod]
 */
export const useChangeClaimType = () =>
  useMutationWithLoading(async (params: Params) =>
    new ClaimControllerApi(getConfigObject()).updateClaimArchiveStatus(
      params.claimId,
      params.claimType,
      getXtenantId()
    )
  );
